import { GET } from '@/utils/request'
import Url from './url'

export const cities = async (params: any) => {
  return await GET({
    url: Url.cities,
    params,
    showError: false
  })
}
